import { render, staticRenderFns } from "./DepartmentAttrs.vue?vue&type=template&id=0e416867"
import script from "./DepartmentAttrs.vue?vue&type=script&lang=js"
export * from "./DepartmentAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports